import React from 'react';
import Select, { Props as SelectProps } from 'react-select';

import styles from './styles';

export interface MultipleSelectProps extends SelectProps {}

function MultipleSelect(props: MultipleSelectProps) {
  return <Select isMulti styles={styles} {...props} />;
}

export default MultipleSelect;
